import axios from '../api/axios';

export const setSessionData = (userdata) => ({
  type: 'SET_SESSION_DATA',
  userdata,
});

export const checkAuth = () => async (dispatch) => {
  try {
    const res = await axios.get('api/user');
    dispatch(setSessionData(res.data.data));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};
